import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConnectionService } from '../../../../services/connection-service';

@Component({
    selector: 'investigation-view',
    templateUrl: './view.html',
    standalone: false,
})
export class ViewComponent implements OnInit {
  investigationId: string;
  investigation: Table.Investigations['attributes'];

  constructor(
    private readonly route: ActivatedRoute,
    private readonly conn: ConnectionService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.investigationId = this.route.snapshot.params['id'];
    this.investigation = await this.conn.findInvestigationById(this.investigationId);
  }
}
